import logo from "./logo.svg";
import "./App.css";
import Formpage from "./components/Formpage";
import Showdata from "./components/Showdata";
import {
  BrowserRouter,
  Routes,
  Route,
  useNavigate,
  useLocation,
} from "react-router-dom";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Nav from "./components/Nav";
import Report from "./components/Report";
import Exportpage from "./components/Exportpage";
import Importpage from "./components/Importpage";
import conf from "./config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loginpage from "./components/Loginpage";
import Cookies from "js-cookie";
import Statuspage from "./components/Statuspage";
import { useMyContext } from "./context/Usecontext";
import CreateEmployee from "./components/CreateEmployee";
import EmployeeList from "./components/EmployeeList";
import Promotetablelist from "./components/Promotetablelist";
import Editpromotetableform from "./components/Editpromotetablefrom";
import NetIncomeForm from "./components/NetIncomeForm";
import Netincomepage from "./components/Netincomepage";
// import DisableYears from "./components/DisableYears";
import AddNewYear from "./components/AddNewYear";
import Departments from "./components/Departments";

function Permissions({ isAdmin, children }) {
  // console.log("permissions");
  // console.log(typeof isAdmin);
  const navigate = useNavigate();
  useEffect(() => {
    if (isAdmin == 0) {
      // toast.error("Access Denied!");
      navigate("/report");
    }
  }, [isAdmin]);
  return children;
}

function App() {
  const [datafedit, setEditdata] = useState(null);
  const [islogin, setIslogin] = useState(false);
  const navigate = useNavigate();
  const { isAdmin, setIsAdmin } = useMyContext();
  const { fname, setFname } = useMyContext();
  const { lname, setLname } = useMyContext();
  const location = useLocation();
  const { dataforedit, setDataforedit } = useMyContext();

  useEffect(() => {
    // console.log("refreshing");

    const isLoggedIn = Cookies.get("isLoggedIn") === "true";
    if (isLoggedIn) {
      // console.log("User is logged in");
      setIslogin(true);
      const isadmin = Cookies.get("isAdmin");
      setIsAdmin(isadmin);
      const fname = Cookies.get("firstname");
      setFname(fname);
      const lname = Cookies.get("lastname");
      setLname(lname);
      // console.log(location.pathname);
      if (location.pathname === "/") navigate("/showdata");
      else {
        if (isadmin == 0) {
          // toast.error("Access Denied!");
          navigate("/report");
        } else {
          navigate(location.pathname);
        }
      }

      // Perform actions for a logged-in user, such as navigating to a specific page
    } else {
      // console.log("User is not logged in");
      setIslogin(false);
      navigate("/");

      // Perform actions for a non-logged-in user, such as redirecting to the login page
    }
  }, []);

  useEffect(() => {
    if (location.pathname !== "/form") {
      setEditdata(null);
    }
  }, [location.pathname]);

  const editdata = async (id, navigate) => {
    try {
      // console.log(id);
      // const response = await axios.get(`${conf.baseurl}/getedit/${id}`);
      const token = Cookies.get("token");
      // console.log(token);
      const config = {
        headers: {
          Authorization: token,
        },
      };
      const response = await axios.get(`${conf.baseurl}/getedit/${id}`, config);
      // console.log("Server response:", response.data);
      setEditdata(response.data);
      navigate("/form");
      // formRef.current.resetFields();
    } catch (error) {
      // console.log('Error submitting form:', error);
      if (error.response && error.response.status === 401) {
        // Redirect to login page
        toast.error("Session expired, Please login again");
        Cookies.remove("isLoggedIn");
        setIslogin(false);
        navigate("/");
      } else {
        // Handle other errors
        console.log("Error submitting form:", error);
      }
    }
  };

  const handleLoginSuccess = () => {
    setIslogin(true);
  };
  const handleLogout = (navigate) => {
    try {
      navigate("/");
      setIslogin(false);
      Cookies.remove("isLoggedIn");
      Cookies.remove("token");
      Cookies.remove("firstname");
      Cookies.remove("lastname");
      Cookies.remove("isAdmin");
    } catch (error) {
      console.error("Error removing cookie:", error);
    }
  };

  return (
    <div>
      <ToastContainer autoClose={2000}></ToastContainer>
      {islogin && (
        <Nav
          setEditdata={setEditdata}
          handleLogout={handleLogout}
          setIslogin={setIslogin}
        ></Nav>
      )}

      <Routes>
        {islogin ? (
          <>
            <Route
              path="/form"
              element={
                <Permissions isAdmin={isAdmin}>
                  <Formpage
                    datafedit={datafedit}
                    setEditdata={setEditdata}
                    setIslogin={setIslogin}
                  />
                </Permissions>
              }
            ></Route>
            <Route
              path="/showdata"
              element={
                <Permissions isAdmin={isAdmin}>
                  <Showdata editdata={editdata} setIslogin={setIslogin} />
                </Permissions>
              }
            ></Route>
            <Route
              path="/report"
              element={
                <Permissions isAdmin={isAdmin}>
                  <Report setIslogin={setIslogin} />
                </Permissions>
              }
            ></Route>
            <Route
              path="/status"
              element={
                <Permissions isAdmin={isAdmin}>
                  <Statuspage setIslogin={setIslogin} />
                </Permissions>
              }
            ></Route>
            <Route
              path="/import"
              element={
                <Permissions isAdmin={isAdmin}>
                  <Importpage setIslogin={setIslogin} />
                </Permissions>
              }
            ></Route>
            <Route
              path="/create"
              element={
                <Permissions isAdmin={isAdmin}>
                  <CreateEmployee setIslogin={setIslogin} />
                </Permissions>
              }
            ></Route>
            <Route
              path="/export"
              element={
                <Permissions isAdmin={isAdmin}>
                  <Exportpage setIslogin={setIslogin} />
                </Permissions>
              }
            ></Route>
            <Route
              path="/employeelist"
              element={
                <Permissions isAdmin={isAdmin}>
                  <EmployeeList setIslogin={setIslogin} />
                </Permissions>
              }
            ></Route>
            <Route
              path="/promotelist"
              element={
                <Permissions isAdmin={isAdmin}>
                  <Promotetablelist setIslogin={setIslogin} />
                </Permissions>
              }
            ></Route>
            <Route
              path="/editpromotedata"
              element={
                <Permissions isAdmin={isAdmin}>
                  <Editpromotetableform setIslogin={setIslogin} />
                </Permissions>
              }
            ></Route>
            <Route
              path="/netincomeform/:id/:year"
              element={
                <Permissions isAdmin={isAdmin}>
                  <NetIncomeForm setIslogin={setIslogin} />
                </Permissions>
              }
            ></Route>
            <Route
              path="/netincome"
              element={
                <Permissions isAdmin={isAdmin}>
                  <Netincomepage setIslogin={setIslogin} />
                </Permissions>
              }
            ></Route>
            {/* <Route
              path="/disableyears"
              element={
                <Permissions isAdmin={isAdmin}>
                  <DisableYears setIslogin={setIslogin} />
                </Permissions>
              }
            ></Route> */}
            <Route
              path="/addnewyear"
              element={
                <Permissions isAdmin={isAdmin}>
                  <AddNewYear setIslogin={setIslogin} />
                </Permissions>
              }
            ></Route>
            <Route
              path="/departments"
              element={
                <Permissions isAdmin={isAdmin}>
                  <Departments setIslogin={setIslogin} />
                </Permissions>
              }
            ></Route>
          </>
        ) : (
          <Route
            path="/"
            element={<Loginpage handleLoginSuccess={handleLoginSuccess} />}
          />
        )}
      </Routes>
      {/* </BrowserRouter> */}
    </div>
  );
}

export default React.memo(App);
